import { Component } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';

import { PaymentService } from '../payment.service';
import { Payment } from '../payment';

@Component({
  selector: 'app-payment-has-been-sent',
  templateUrl: './payment-has-been-sent.component.html',
  styleUrls: ['./payment-has-been-sent.component.less'],
  standalone: false
})
export class PaymentHasBeenSentComponent {
  payment$: Observable<Payment>;

  constructor(
    private modal: NzModalRef,
    private paymentService: PaymentService
  ) {
    this.payment$ = this.paymentService.paymentSummary$;
  }

  done(): void {
    this.modal.destroy();
  }
}
